import type { BizIconProps } from './base';
import BizIconSvg from './base';

/**
 * IconHangup — 挂断（放下听筒）：呼出听筒路径顺时针转向水平横放（弧面朝上、两端朝下），
 * 与「呼出」斜放听筒一眼可分。
 */
export default function IconHangup(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <path
        transform="rotate(225 8 8)"
        d="M2.24 11.43a0.33 0.33 0 0 1 0-0.47l1.89-1.89a0.33 0.33 0 0 1 0.47 0l1.65 1.65s1.18-0.47 2.59-1.89c1.41-1.41 1.89-2.59 1.89-2.59l-1.65-1.65a0.33 0.33 0 0 1 0-0.47l1.89-1.89a0.33 0.33 0 0 1 0.47 0l2 2s1.06 2.48-2.83 6.36c-3.89 3.89-6.36 2.83-6.36 2.83l-2-2Z"
      />
    </BizIconSvg>
  );
}
